module.exports = __webpack_public_path__ + "static/media/image-howto-3.0fa2e96f.jpg";